import { isObject } from '../is-object';
export function isNodeSchema(data) {
  if (!isObject(data)) {
    return false;
  }
  return 'componentName' in data && !data.isNode;
}